import {
	MATCH_FETCH,
	MATCH_FETCH_SUCCESS,
	MATCH_FETCH_FAIL,
	MATCH_FETCH_DETAIL_SUCCESS,
	MATCH_TOGGLE_EDIT,
	MATCH_EDIT_SEASONID_CHANGE,
	MATCH_EDIT_POSTID_TEXT_CHANGE,
	MATCH_EDIT_NAME_TEXT_CHANGE,
	MATCH_EDIT_DESC_TEXT_CHANGE,
	MATCH_EDIT_FORMATION_CHANGE,
	MATCH_EDIT_ACTIVE_CHANGE,
	MATCH_UPDATE_SUCCESS,
	MATCH_UPDATE_FAIL,
	MATCH_NEW_SUCCESS,
	MATCH_DELETE_SUCCESS,
	MATCH_DELETE_FAIL,
	MATCH_EDIT_TEMP_FREEZE_CHANGE,
	MATCH_EDIT_BONUS_TEXT_CHANGE,
} from '../actions/types';

const INITIAL_STATE = {
	loading: false,
	list: {},
	listByID: [],
	errorText: '',
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case MATCH_FETCH:
			return { ...state, loading: true, errorText: '' };

		case MATCH_FETCH_SUCCESS:
			return {
				...state,
				loading: false,
				list: action.payload,
				listByID: action.listByID.sort((a, b) => b - a),
			};

		case MATCH_FETCH_FAIL:
			return { ...state, loading: false, errorText: action.payload };

		case MATCH_FETCH_DETAIL_SUCCESS:
			const copyDetail = Object.assign({}, state.list);
			copyDetail[action.id] = {
				...copyDetail[action.id],
				...action.payload,
			};
			return { ...state, list: copyDetail };

		case MATCH_TOGGLE_EDIT:
			const copyToggleEdit = Object.assign({}, state.list);
			copyToggleEdit[action.id] = {
				...copyToggleEdit[action.id],
				readOnly: !state.list[action.id].readOnly,
				onChange: {
					...copyToggleEdit[action.id].onChange,
					...state.list[action.id],
					onChange: {},
				},
			};
			return { ...state, list: copyToggleEdit };

		case MATCH_EDIT_SEASONID_CHANGE:
			const copySeasonIdChange = Object.assign({}, state.list);
			copySeasonIdChange[action.id].onChange = {
				...copySeasonIdChange[action.id].onChange,
				season_id: action.payload,
			};
			return { ...state, list: copySeasonIdChange };
		case MATCH_EDIT_POSTID_TEXT_CHANGE:
			const copyPostIdTextChange = Object.assign({}, state.list);
			copyPostIdTextChange[action.id].onChange = {
				...copyPostIdTextChange[action.id].onChange,
				postId: action.payload,
			};
			return { ...state, list: copyPostIdTextChange };
		case MATCH_EDIT_NAME_TEXT_CHANGE:
			const copyNameTextChange = Object.assign({}, state.list);
			copyNameTextChange[action.id].onChange = {
				...copyNameTextChange[action.id].onChange,
				title: action.payload,
			};
			return { ...state, list: copyNameTextChange };
		case MATCH_EDIT_DESC_TEXT_CHANGE:
			const copyDescTextChange = Object.assign({}, state.list);
			copyDescTextChange[action.id].onChange = {
				...copyDescTextChange[action.id].onChange,
				description: action.payload,
			};
			return { ...state, list: copyDescTextChange };
		case MATCH_EDIT_BONUS_TEXT_CHANGE:
			const copyBonusTextChange = Object.assign({}, state.list);
			copyBonusTextChange[action.id].onChange = {
				...copyBonusTextChange[action.id].onChange,
				bonus: action.payload,
			};
			return { ...state, list: copyBonusTextChange };
		case MATCH_EDIT_FORMATION_CHANGE:
			const copyFormationChange = Object.assign({}, state.list);
			copyFormationChange[action.id].onChange = {
				...copyFormationChange[action.id].onChange,
				formation: action.payload.name,
				formation_id: action.payload.id,
			};
			return { ...state, list: copyFormationChange };
		case MATCH_EDIT_ACTIVE_CHANGE:
			const copyActiveChange = Object.assign({}, state.list);
			copyActiveChange[action.id].onChange = {
				...copyActiveChange[action.id].onChange,
				active: action.payload,
			};
			return { ...state, list: copyActiveChange };

		case MATCH_UPDATE_SUCCESS:
			const copyUpdate = Object.assign({}, state.list);
			copyUpdate[action.id] = {
				...action.payload,
				onChange: action.payload,
				readOnly: true,
			};
			return { ...state, list: copyUpdate };

		case MATCH_UPDATE_FAIL:
			const copyUpdateFail = Object.assign({}, state.list);
			copyUpdateFail[action.id] = {
				...copyUpdateFail[action.id],
				error: action.error,
				errorText: action.errorText,
			};
			return { ...state, list: copyUpdateFail };

		case MATCH_NEW_SUCCESS:
			const copyNew = Object.assign({}, state.list);
			let copyNewById = state.listByID.slice();
			copyNew[parseInt(action.id, 10)] = {
				...copyNew[parseInt(action.id, 10)],
				...action.payload,
				readOnly: true,
				onChange: action.payload,
			};
			copyNewById = [parseInt(action.id, 10), ...copyNewById];
			return { ...state, list: copyNew, listByID: copyNewById.sort((a, b) => b - a) };

		case MATCH_DELETE_SUCCESS:
			const copyDeleteById = state.listByID.filter(v => v !== action.id);
			const copyDelete = Object.keys(state.list).reduce((obj, key) => {
				if (parseInt(key, 10) !== action.id) {
					return { ...obj, [key]: state.list[key] };
				}
				return obj;
			}, {});
			return { ...state, list: copyDelete, listByID: copyDeleteById.sort((a, b) => b - a) };
		case MATCH_DELETE_FAIL:
			const copyDeleteFail = Object.assign({}, state.list);
			copyDeleteFail[action.id] = {
				...copyDeleteFail[action.id],
				error: action.error,
				errorText: action.errorText,
			};
			return { ...state, list: copyDeleteFail };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/MatchReducer.js